import { createContext, useContext } from 'react';
import { DropdownContextValue, SubContextValue } from './dropdown.types';

export const DropdownContext = createContext<DropdownContextValue | null>(null);
export const SubContext = createContext<SubContextValue | null>(null);

export const useDropdown = () => {
  const ctx = useContext(DropdownContext);

  if (!ctx) {
    throw new Error('useDropdown должен быть внутри <Dropdown.Root>');
  }

  return ctx;
};

export const useSubContext = () => {
  const ctx = useContext(SubContext);

  if (!ctx) {
    throw new Error('useSubContext must be used within Dropdown.Sub');
  }

  return ctx;
};
